type ImageProps = React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> & {
  alt: string;
  scale: number;
};

export const SquareImage = (props: ImageProps) => {
  return (
    // eslint-disable-next-line jsx-a11y/alt-text
    <img className="self-center" {...props} width={`${props.scale}px`} height={`${props.scale}px`} />
  );
};

export default SquareImage;
